/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import cx from "classnames";
import ReactGA from "react-ga";

import axios from "axios";
import classes from "./FormSelectYourSeat.module.scss";
import colours from "./SeatingMap.module.scss";
import FormTitle from "../FormTitle/FormTitle";
import * as ROUTES from "../../constants/routes";
import FormController from "../../components/FormController/FormController";
import SelectNumOfSeatsModal from "./SelectNumOfSeatsModal/SelectNumOfSeatsModal";
import SeatingMap from "./SeatingMap";
import SeatMapModal from "./SeatMapModal";
import Spinner from "../Loader/Spinner";
class FormSelectYourSeat extends Component {
  componentDidMount() {
    this.setState({
      seatInfoSelectedKey: "",
      seatDropdown: false,
      showMapModal: false,
    });
    this.props.updateMultipleSelectedChoices({
      seatInfoSelected: "",
    });
    if (this.props.formStart === "") {
      this.props.history.push("/");
    } else {
      if (window.adobeAnalytics) {
        window.adobeAnalytics.t({
          pageName:
            "Washington Nationals: Tickets: Nationals Ticketfinder: Select your seats",
        });
      }
    }

    ReactGA.pageview("/select-your-seats");
    if (this.props.numOfSeat !== "") {
      if (this.props.formSize !== "ballPark") {
        this.setState({
          numOfSeatsModalConfirm: true,
        });
      }
    }
    if (this.props.formStyle === "flexible") {
      this.props.updateSelectedChoices("numOfSeat", 1);
      this.setState({
        numOfSeatsModalConfirm: true,
      });
    }
    if (this.props["selectYourSeatsUuid"] !== "") {
      axios
        .post(
          process.env.NODE_ENV === "development"
            ? "https://nationals.vipfanportal.com/ticketfinder-uat/getAvailability"
            : "https://nationals.vipfanportal.com/ticketfinder/getAvailability",
          {
            uuid: this.props["selectYourSeatsUuid"],
            q: this.props.numOfSeat !== "" ? this.props.numOfSeat : 1,
          }
        )
        .then((response) => {
          if (response.data.status !== "error") {
            this.setState({ seatsInfo: response.data.info, error: false });
          } else {
            console.log("error", response.data.message);

            this.setState({ error: true });
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.setState({ error: true });
        });
    }
    this.createplans();
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.numOfSeats !== this.state.numOfSeats ||
      prevProps.selectYourSeatsUuid !== this.props.selectYourSeatsUuid
    ) {
      axios
        .post(
          process.env.NODE_ENV === "development"
            ? "https://nationals.vipfanportal.com/ticketfinder-uat/getAvailability"
            : "https://nationals.vipfanportal.com/ticketfinder/getAvailability",
          {
            uuid: this.props["selectYourSeatsUuid"],
            q: this.props.numOfSeat !== "" ? this.props.numOfSeat : 1,
          }
        )
        .then((response) => {
          console.log("response.data.info", response.data.info);
          if (response.data.status !== "error") {
            this.setState({ seatsInfo: response.data.info, error: false });
          } else {
            console.log("error", response.data.message);

            this.setState({ error: true });
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.setState({ error: true });
        });
    }
  }
  onClickDifferentPlan = () => {
    if (this.props.formSize === "fortyClassic") {
      this.setState({
        loaderShow: true,
      });
      setTimeout(() => {
        this.setState({
          loaderShow: false,
        });
      }, 1000);
      if (this.props.selectYourSeatsUuid === "zN6VE3n0B5") {
        this.props.updateSelectedChoices("selectYourSeatsUuid", "CAFbHgRVNg");
      } else {
        this.props.updateSelectedChoices("selectYourSeatsUuid", "zN6VE3n0B5");
      }
    } else {
      this.props.history.push({
        pathname: "recommended-plan",
        state: { showModal: true },
      });
    }
  };
  onClickSelectSeat = (index) => {
    this.setState({
      seatInfoSelectedKey: index,
    });
    this.props.updateSelectedChoices(
      "seatInfoSelected",
      this.state.seatsInfo[index]
    );
  };
  onMouseEnterSeat = (index) => {
    this.setState({
      seatInfoHoveredKey: this.state.seatsInfo[index],
    });
  };
  onMouseOutSeat = (index) => {
    this.setState({
      seatInfoHoveredKey: null,
    });
  };
  onClickNumOfSeatItem = (numOfSeats) => {
    this.setState({
      numOfSeats: numOfSeats,
    });
    this.props.updateSelectedChoices("numOfSeat", numOfSeats);
  };
  onClickNumOfSeatModalConfirm = () => {
    if (this.props.formSize === "ballPark") {
      this.setState((prevState) => ({
        numOfSeatsModalConfirm: !prevState.numOfSeatsModalConfirm,
      }));
      this.props.updateSelectedChoices(
        "seatInfoSelected",
        this.state.seatsInfo[0]
      );
      this.props.history.push("checkout");
    } else {
      this.setState((prevState) => ({
        numOfSeatsModalConfirm: !prevState.numOfSeatsModalConfirm,
      }));
    }
  };
  onClickToggleSeatDropdown = () => {
    this.setState((prevState) => ({
      seatDropdown: !prevState.seatDropdown,
    }));
  };
  onClickCloseMapModal = () => {
    this.setState({ showMapModal: false });
  };
  onClickOpenMapModal = () => {
    this.setState({ showMapModal: true });
  };
  state = {
    seatsInfo: "",
    error: false,
    seatInfoSelectedKey: "",
    numOfSeats: "",
    numOfSeatsModalConfirm: false,
  };
  openChatPopUp = () => {
    window.chatBtn();
  };
  async createplans() {
    if (this.props.cms) {
      let _planSchedules = {};

      const cms = this.props.cms;

      await cms.forEach(async (style, index) => {
        await style.plans.forEach((plan) => {
          plan.schedules.forEach((schedule) => {
            _planSchedules[schedule.UUID] = {
              planTitle: plan.name,
              planName: schedule.name,
              adaLink: schedule.adaUrl,
              switchPlanMsg: schedule.switchPlanMsg,
              flexMultiply: schedule.flexMultiply || 1,
            };
          });
        });
      });
      this.setState({
        planSchedules: _planSchedules,
      });
    }
  }
  render() {
    let seatNumberArr = [1, 2, 3, 4, 5, 6];
    if (!this.state.planSchedules) {
      return <p>Loadinng ...</p>;
    }

    if (this.state.error) {
      return (
        <>
          <div className={classes.errorMsg}>
            <p> Sorry! There is an error, please try again later.</p>
          </div>
          <FormController
            backTo={ROUTES.PAGE_5_LINK}
            nextTo="checkout"
            startOver={ROUTES.PAGE_1_LINK}
            showBack={true}
            showStartOver={true}
            showSkip={false}
            showSubmit={true}
            disableSubmit={this.state.seatInfoSelectedKey === ""}
          />
        </>
      );
    }
    let planTitle =
      this.state.planSchedules[this.props["selectYourSeatsUuid"]].planTitle;
    let planName =
      this.state.planSchedules[this.props["selectYourSeatsUuid"]].planName;
    let adaLink =
      this.state.planSchedules[this.props["selectYourSeatsUuid"]].adaLink;
    let switchPlanMsg =
      this.state.planSchedules[this.props["selectYourSeatsUuid"]].switchPlanMsg;
    let flexMultiply =
      this.state.planSchedules[this.props["selectYourSeatsUuid"]].flexMultiply;

    let showSeatInfo =
      this.state.seatsInfo !== "" &&
      typeof this.state.seatsInfo !== "undefined" ? (
        this.state.seatsInfo.map((res, index) => (
          <div
            key={index}
            className={cx(
              classes.listOfSeatRow,
              this.state.seatInfoSelectedKey === index
                ? classes.seatInfoSelected
                : ""
            )}
            onClick={() => this.onClickSelectSeat(index)}
            onMouseEnter={() => this.onMouseEnterSeat(index)}
            onMouseLeave={() => this.onMouseOutSeat()}
          >
            <div className={classes.seatTitle}>
              <span
                className={
                  colours[res.name.toLowerCase().replace(/[/ ]/g, "_")]
                }
              ></span>
              <div className={classes.seatName}>{res.name}</div>
            </div>
            <div className={classes.price}>
              $
              {this.props.formStyle === "classic"
                ? res.price.toLocaleString("en-US")
                : (res.price * flexMultiply).toLocaleString("en-US")}
            </div>
            <div className={classes.selectSeatButton}>Select</div>
          </div>
        ))
      ) : (
        <div
          className={cx(
            classes.loader__wrapper,
            this.state.loaderShow ? classes.loader__wrapper__active : ""
          )}
        >
          <div className={classes.loader}>
            <Spinner />
          </div>
        </div>
      );
    return this.props["selectYourSeatsUuid"] !== "" ? (
      <div>
        <FormTitle title="Select Your Seats" />
        <div className={classes.FormSelectYourSeat}>
          <div className={classes.listOfSeats}>
            <div className={classes.toggleNumOfSeatModalHeader}>
              <div
                className={cx(
                  classes.textHeader,
                  this.props.formStyle === "classic"
                    ? classes.textHeaderBig
                    : ""
                )}
              >
                {this.props.formStyle === "classic" ? (
                  <p>
                    Choose your preferred seating area, and TicketFinder will
                    provide you with the best seats available in that location.
                  </p>
                ) : (
                  <p>
                    Choose your preferred seating area below. The vouchers for
                    your Flexible Plan will be good for this location. As you
                    redeem your vouchers on a fluid basis througout the season,
                    you will claim your exact seats for each game.
                  </p>
                )}
              </div>
              <div
                className={classes.toggleNumOfSeatButton}
                onClick={() => this.onClickToggleSeatDropdown()}
              >
                <span>
                  {this.props.numOfSeat !== "" ? this.props.numOfSeat : "1"}{" "}
                  {this.props.formStyle === "classic" ? "Seat" : "Plan"}
                  {this.props.numOfSeat !== 1 ? "s" : ""}
                </span>
                <i className={"fa fa-chevron-down"} aria-hidden="true"></i>
                <div
                  className={cx(
                    classes.toggleNumSeatDropdown,
                    this.state.seatDropdown === true ? classes.active : ""
                  )}
                >
                  <ul>
                    {seatNumberArr.map((seatNum, i) => (
                      <li
                        key={i}
                        className={
                          this.state.numOfSeats === seatNum
                            ? classes.seatActive
                            : ""
                        }
                        onClick={() => this.onClickNumOfSeatItem(seatNum)}
                      >
                        {seatNum}{" "}
                        {seatNum === 1
                          ? this.props.formStyle === "classic"
                            ? "Seat"
                            : "Plan"
                          : this.props.formStyle === "classic"
                          ? "Seats"
                          : "Plans"}
                        <i className={"fa fa-check"} aria-hidden="true"></i>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className={classes.showSeatInfoTitle}>
                <span>Section Name</span>
                <span>
                  Price per{" "}
                  {this.props.formStyle === "classic" ? "Seat" : "Plan"}
                </span>
              </div>
            </div>

            <div className={classes.showSeatInfoWrapperWrapper}>
              <div className={classes.showSeatInfoWrapper}>
                {this.state.loaderShow ? (
                  <div
                    className={cx(
                      classes.loader__wrapper,
                      this.state.loaderShow
                        ? classes.loader__wrapper__active
                        : ""
                    )}
                  >
                    <div className={classes.loader}>
                      <Spinner />
                    </div>
                  </div>
                ) : (
                  showSeatInfo
                )}
              </div>
            </div>
          </div>
          <div className={classes.map}>
            <div className={classes.planTitle}>
              {planTitle} <br />
              {this.props.formStyle === "classic" && planTitle !== planName && (
                <>({planName})</>
              )}
            </div>
            {this.state.seatsInfo !== "" &&
            typeof this.state.seatsInfo !== "undefined" ? (
              <a
                className={classes.map_wrapper}
                onClick={() => this.onClickOpenMapModal()}
              >
                <div className={classes.expand}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                  >
                    <path
                      fill="#000847"
                      fillRule="nonzero"
                      d="M13.338.16a.442.442 0 0 0-.054.005h.002-3.853a.488.488 0 1 0 0 .976h2.735L9.095 4.215a.489.489 0 0 0 .69.691l3.074-3.073v2.734a.488.488 0 1 0 .977 0V.713a.488.488 0 0 0-.484-.553h-.015.001zM.642 8.95a.489.489 0 0 0-.482.489v3.916c0 .015 0 .029.002.042v-.002.008-.001c.001.014.004.027.006.039v-.003a.51.51 0 0 0 .002.017v-.003a.49.49 0 0 0 .046.128v-.003l.006.014v-.003a.527.527 0 0 0 .02.033L.24 13.62a.127.127 0 0 0 .007.01H.246a.495.495 0 0 0 .094.1v.001l.005.004c.08.064.181.102.291.105h3.926a.488.488 0 1 0 0-.977H1.827L4.9 9.79a.487.487 0 0 0-.34-.839h-.015a.488.488 0 0 0-.335.148l-3.074 3.074V9.445v-.006a.488.488 0 0 0-.488-.489H.64h.002z"
                    />
                  </svg>
                </div>

                <SeatingMap
                  seatsInfo={this.state.seatsInfo}
                  seatInfoSelectedKey={this.state.seatInfoSelectedKey}
                  hoveredItem={this.state.seatInfoHoveredKey}
                />
              </a>
            ) : (
              <div
                className={cx(
                  classes.loader__wrapper,
                  this.state.loaderShow ? classes.loader__wrapper__active : ""
                )}
              >
                <div className={classes.loader}>
                  <Spinner />
                </div>
              </div>
            )}
          </div>
          <div className={classes.thirdCol}>
            {switchPlanMsg && switchPlanMsg !== "" ? (
              <div
                className={classes.differentPlan}
                onClick={() => this.onClickDifferentPlan()}
              >
                <div className={classes.blueButton}>Switch Your Schedule</div>
                <div className={classes.description}>{switchPlanMsg}</div>
              </div>
            ) : (
              ""
            )}
            <div className={classes.premiumSales}>
              <a onClick={this.openChatPopUp} className={classes.blueButton}>
                Interested in Premium Seats?
              </a>
              <div className={classes.description}>
                Click here to chat with a Nationals representative about Premium
                seating options with all-inclusive food & beverage and access to
                exclusive indoor club areas
              </div>
            </div>
            {this.props.formStyle === "classic" && (
              <div className={classes.ada}>
                <a
                  href={adaLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.blueButton}
                >
                  Interested in ADA Seats?
                </a>
                <div className={classes.description}>
                  Click here to view ADA seating options
                </div>
              </div>
            )}
          </div>
        </div>
        <FormController
          backTo={ROUTES.PAGE_5_LINK}
          nextTo="checkout"
          startOver={ROUTES.PAGE_1_LINK}
          showBack={true}
          showStartOver={true}
          showSkip={false}
          showSubmit={true}
          disableSubmit={this.state.seatInfoSelectedKey === ""}
        />

        <SelectNumOfSeatsModal
          onClickNumOfSeatItem={this.onClickNumOfSeatItem}
          numOfSeatsSelected={this.state.numOfSeats}
          numOfSeatsModalConfirm={this.state.numOfSeatsModalConfirm}
          onClickNumOfSeatModalConfirm={this.onClickNumOfSeatModalConfirm}
          formStyle={this.props.formStyle}
        />
        <SeatMapModal
          showMapModal={this.state.showMapModal}
          seatsInfo={this.state.seatsInfo}
          seatInfoSelectedKey={this.state.seatInfoSelectedKey}
          hoveredItem={this.state.seatInfoHoveredKey}
          onClickCloseMapModal={this.onClickCloseMapModal}
        />
      </div>
    ) : (
      <div className={classes.errorMsg}>Please select the correct plan</div>
    );
  }
}

export default FormSelectYourSeat;
